import * as React from 'react';

import styles from './codetable-item-loader.scss';

export interface CodetableItemLoaderProps {
  isZebra?: boolean;
  children?: React.ReactNode;
}

export const CodetableItemLoader: React.FC<CodetableItemLoaderProps> = ({ children, isZebra = false }: CodetableItemLoaderProps) =>
  <div className={isZebra ? styles.zebra : ''}>
    <div className={styles.loaderText}>{children}</div> <div className={styles.spinLoader} />
  </div>;
